import { action, computed, observable } from "mobx";
import { Api } from "../../api";
import { Warenkorb } from "../../common/interfaces/Warenkorb";
import { Store } from "../index";

export class WarenkorbState {
  // RootStore
  public rootStore: Store;

  public constructor(store: Store) {
    this.rootStore = store;
  }

  @observable
  public aktuellerWarenkorb?: Warenkorb;

  @computed
  public get totalAmount() {
    if (this.aktuellerWarenkorb) {
      return this.aktuellerWarenkorb.amount;
    } else {
      return 0;
    }
  }

  @computed
  public get indexedEntries() {
    let result = {};
    if (this.aktuellerWarenkorb) {
      this.aktuellerWarenkorb.entries.slice().forEach((entry) => {
        result[entry.biid] = entry.amount;
      });
    }

    return result;
  }

  @action.bound
  public async update(biid, amount) {
    this.aktuellerWarenkorb = await Api.warenkorb.updateAktuellerWarenkorb(
      biid,
      amount
    );
  }

  @action.bound
  public async leeren() {
    this.aktuellerWarenkorb = await Api.warenkorb.aktuellenWarenkorbLeeren();
  }

  @action.bound
  public async getCurrent() {
    this.aktuellerWarenkorb = await Api.warenkorb.getAktuellerWarenkorb();
  }

  public getValue(biid) {
    return this.indexedEntries[biid] || 0;
  }
}
